import { EXPERIMENTAL_Suggestion as DigdirSuggestion, EXPERIMENTAL_SuggestionClear as SuggestionClear, EXPERIMENTAL_SuggestionEmpty as SuggestionEmpty, EXPERIMENTAL_SuggestionInput as SuggestionInput, EXPERIMENTAL_SuggestionList as SuggestionList, EXPERIMENTAL_SuggestionOption as SuggestionOption, } from "@digdir/designsystemet-react";
const Suggestion = DigdirSuggestion;
Suggestion.displayName = "Suggestion";
SuggestionClear.displayName = "Suggestion.Clear";
SuggestionEmpty.displayName = "Suggestion.Empty";
SuggestionInput.displayName = "Suggestion.Input";
SuggestionList.displayName = "Suggestion.List";
SuggestionOption.displayName = "Suggestion.Option";
export { Suggestion, SuggestionClear, SuggestionEmpty, SuggestionInput, SuggestionList, SuggestionOption, };
//# sourceMappingURL=suggestion.js.map